import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { Menu, Transition } from "@headlessui/react";
import {
  DashboardIcon,
  DownArrowIcon,
  EuroIcon,
  QuestionIcon,
  RecipientIcon,
  SupportIcon,
  TransactionIcon,
} from "./Swicons";

export default function TopBar() {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("User Name");
  const [userDropdown, setUserDropdown] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [menuDropdown, setMenuDropdown] = useState(false);
  const pathname = window.location.pathname;
  useEffect(() => {}, [userDropdown]);
  useEffect(() => {
    const handleClose = () => {
      setIsOpen(false);
    };
    const handleDropdownClose = () => {
      setUserDropdown(false);
    };
    window.addEventListener("click", handleClose);
    window.addEventListener("click", handleDropdownClose);
    return () => {
      window.removeEventListener("click", handleClose);
      window.removeEventListener("click", handleDropdownClose);
    };
  }, []);

  const logOut = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <>
      <nav className="topmenu  z-50 flex-wrap p-2 px-3 fixed w-full border-b dashboard-top-menu ">
        <div className="w-full flex-grow flex items-center justify-between">
          <div className="flex lg:hidden">
            <button
              onClick={(e) => {
                e.stopPropagation();
                setIsOpen(!isOpen);
                setUserDropdown(false);
              }}
              type="button"
              className="inline-flex items-center justify-end p-2 rounded-md text-gray-400 hover:text-sky-800 hover:bg-themeHover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-sky-800 focus:ring-white"
              aria-controls="mobile-menu"
              aria-expanded="false"
              style={{ backgroundColor: "#ffffff" }}
            >
              <span className="sr-only">Open main menu</span>
              {!isOpen ? (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              ) : (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              )}
            </button>
          </div>
          <div>
            <Link to="/">
              <img
                src="./../../images/logo.png"
                className="w-32 ml-10 h-15 lg:w-48 lg:ml-0"
                alt="ScopeX"
              />
            </Link>
          </div>

          <div className="relative inline-block text-left basis-0/6">
            <div>
              <button
                type="button"
                className="dashboard-top-menu flex justify-end items-center w-full rounded-md text-sm font-medium text-gray-700 "
                onClick={(e) => {
                  e.stopPropagation();
                  setUserDropdown(!userDropdown);
                  setIsOpen(false);
                }}
              >
                <svg
                  width="52"
                  height="52"
                  viewBox="0 0 52 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-2"
                >
                  <circle cx="26" cy="26" r="26" fill="#ffffff" />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.3334 18.6875C20.3334 15.6557 22.8704 13.1979 26 13.1979C29.1296 13.1979 31.6667 15.6557 31.6667 18.6875C31.6667 21.7193 29.1296 24.1771 26 24.1771C22.8704 24.1771 20.3334 21.7193 20.3334 18.6875ZM26 15.1354C23.975 15.1354 22.3334 16.7258 22.3334 18.6875C22.3334 20.6493 23.975 22.2396 26 22.2396C28.0251 22.2396 29.6667 20.6493 29.6667 18.6875C29.6667 16.7258 28.0251 15.1354 26 15.1354Z"
                    fill="black"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.6667 28.0521C19.0098 28.0521 17.6667 29.3533 17.6667 30.9584V32.4932C17.6667 32.5166 17.6842 32.5365 17.708 32.5403C23.1997 33.4089 28.8004 33.4089 34.2921 32.5403C34.3159 32.5365 34.3334 32.5166 34.3334 32.4932V30.9584C34.3334 29.3533 32.9902 28.0521 31.3334 28.0521H30.8789C30.8437 28.0521 30.8088 28.0575 30.7754 28.0681L29.6214 28.4331C27.2683 29.1774 24.7318 29.1774 22.3787 28.4331L21.2246 28.0681C21.1912 28.0575 21.1563 28.0521 21.1212 28.0521H20.6667ZM15.6667 30.9584C15.6667 28.2832 17.9053 26.1146 20.6667 26.1146H21.1212C21.3672 26.1146 21.6116 26.1523 21.8455 26.2263L22.9995 26.5913C24.9492 27.208 27.0509 27.208 29.0006 26.5913L30.1546 26.2263C30.3884 26.1523 30.6329 26.1146 30.8789 26.1146H31.3334C34.0948 26.1146 36.3334 28.2832 36.3334 30.9584V32.4932C36.3334 33.4661 35.6055 34.2957 34.6143 34.4525C28.9092 35.3548 23.0908 35.3548 17.3857 34.4525C16.3945 34.2957 15.6667 33.4661 15.6667 32.4932V30.9584Z"
                    fill="black"
                  />
                </svg>

                <svg
                  className="-mr-1 ml-2 h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="#ffffff"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
            <div
              className={
                "origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none " +
                (userDropdown ? "show" : "hidden")
              }
            >
              <div className="py-1" role="none">
                <Link
                  to="/myprofile"
                  className="text-gray-700 block px-4 py-2 text-sm"
                  role="menuitem"
                  tabIndex="-1"
                  id="menu-item-0"
                >
                  {localStorage.getItem("SXUser")}'s Profile
                </Link>
                <Link
                  to="/invite"
                  className="text-gray-700 block px-4 py-2 text-sm"
                  role="menuitem"
                  tabIndex="-1"
                  id="menu-item-0"
                >
                  Invite friends
                </Link>
                <Link
                  to="/Change-Password"
                  className="text-gray-700 block px-4 py-2 text-sm"
                  role="menuitem"
                  tabIndex="-1"
                  id="menu-item-0"
                >
                  Change Password
                </Link>
                <a
                  href="#"
                  className="text-gray-700 block px-4 py-2 text-sm"
                  role="menuitem"
                  tabIndex="-1"
                  id="menu-item-1"
                  onClick={logOut}
                >
                  Log out
                </a>
              </div>
            </div>
          </div>
        </div>
        <Transition
          show={isOpen}
          enter="transition ease-out duration-100 transform"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="transition ease-in duration-75 transform"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          {(ref) => (
            <div className="md:hidden font-nunito text-center" id="mobile-menu">
              <div ref={ref}>
                <ul className="text-white mt-2">
                  <li className={pathname == "/Dashboard" ? "menu-active" : ""}>
                    <Link
                      to="/Dashboard"
                      className="relative py-3 px-2 md:px-3 lg:px-4 text-lg lg:text-base font-bold rounded items-center"
                      style={{ WebkitTapHighlightColor: "transparent" }}
                    >
                      <p>Dashboard</p>
                    </Link>
                  </li>
                  {/* <li className="">
                    <Link to="/Track">
                      <button className="relative py-3 px-2 md:px-3 lg:px-4 text-lg lg:text-base font-bold rounded items-center">
                        Track transfer
                      </button>
                    </Link>
                  </li> */}
                  <li
                    className={
                      pathname == "/Add-Transaction" ? "menu-active" : ""
                    }
                  >
                    <Link
                      to="/Add-Transaction"
                      className="relative py-3 px-2 md:px-3 lg:px-4 text-lg lg:text-base font-bold rounded items-center"
                      style={{ WebkitTapHighlightColor: "transparent" }}
                    >
                      <p className="-mt-8">Send Money</p>
                    </Link>
                  </li>
                  <li
                    className={
                      pathname == "/Transaction-List" ||
                      pathname == "/Transaction-List"
                        ? "menu-active"
                        : ""
                    }
                  >
                    <Link
                      to="/Transaction-List"
                      className="relative py-3 px-2 md:px-3 lg:px-4 text-lg lg:text-base font-bold rounded items-center focus:outline-none active:bg-transparent"
                      style={{ WebkitTapHighlightColor: "transparent" }}
                    >
                      <p className="-mt-8">Transfer History</p>
                    </Link>
                  </li>

                  <li
                    className={
                      pathname == "/Recipient-List" ||
                      pathname == "/Add-Recipient"
                        ? "menu-active"
                        : ""
                    }
                  >
                    <button
                      type="button"
                      className="relative py-3 px-2 md:px-3 lg:px-4 text-lg lg:text-base font-bold rounded items-center transition duration-75 group"
                      style={{ WebkitTapHighlightColor: "transparent" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setMenuDropdown(!menuDropdown);
                      }}
                    >
                      <span
                        className="flex justify-center whitespace-nowrap"
                        sidebar-toggle-item=""
                      >
                        <p className="-mt-8">Recipients</p>
                        <div className="-mt-7 ml-1">
                          <DownArrowIcon />
                        </div>
                      </span>
                    </button>
                    <ul
                      className={
                        "submenu py-2 space-y-2 " +
                        (menuDropdown ? "show" : "hidden")
                      }
                    >
                      <li>
                        <Link
                          to="/Recipient-List"
                          className="relative py-3 px-2 md:px-3 lg:px-4 text-lg lg:text-base font-bold rounded items-center transition duration-75 group"
                          style={{ WebkitTapHighlightColor: "transparent" }}
                        >
                          <p className="-mt-6">Recipient List</p>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/Add-Recipient"
                          className="relative py-3 px-2 md:px-3 lg:px-4 text-lg lg:text-base font-bold rounded items-center transition duration-75 group"
                          style={{ WebkitTapHighlightColor: "transparent" }}
                        >
                          <p className="-mt-8">Add Recipient</p>
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </Transition>
      </nav>
    </>
  );
}
